import { DonutChartData } from "@/components/visualizations/DonutChart/DonutChart";
import SingleBarChart from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import useTranslation from "@/hooks/useTranslation";
import { useCompanyImpactTotals } from "@/pages/dashboard/hooks/useCompanyImpact";
import { formatCarbonFootprintLabel } from "@/pages/dashboard/utils/formatters";
import Widget from "../../components/Widget/Widget";
import { IMPACT_METRICS } from "@/pages/dashboard/utils/types";

export default function CorporateImpactPerScope() {
  const { data, isLoading, isFetching } = useCompanyImpactTotals({
    metrics: [
      "carbon_footprint",
      "carbon_footprint_scope_1",
      "carbon_footprint_scope_2",
      "carbon_footprint_scope_3",
    ],
  });
  const translation = useTranslation();

  const chartData: DonutChartData = data?.company_impact
    ? Object.entries(data?.company_impact)
        .filter(([label]) => label !== "carbon_footprint" && label.includes("carbon_footprint"))
        .map(([label, value]) => ({
          label: formatCarbonFootprintLabel(label),
          value: value || 0,
        }))
        .sort((a, b) => (a.label < b.label ? -1 : 1))
    : [];

  return (
    <Widget
      title={"Company impact per scope"}
      tooltip={translation["dashboard"]["company"]["per_scope"]}
    >
      <SingleBarChart
        data={chartData}
        colorPalette="scope"
        format={IMPACT_METRICS.carbon_footprint.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}
